PluginRunner = require 'views/internal/plugins/plugin-runner'
React = require 'react'
t = require('views/internal/recup-with-helpers')('plugin_auth')
xtend = require 'xtend'
_ = require 'underscore'

template  = t.renderable ({ supportsSettings, supportsAuth, hasPersonalSettings, authStatus, authorize, removeData, showSettings } = {}) ->
  t.ul '.pop-over-list', ->
    if supportsAuth && !(authStatus && authStatus.authorized)
      t.li onClick: authorize, ->
        t.a ->
          t.format 'authorize-account'
    else
      if supportsSettings
        t.li onClick: showSettings, ->
          t.a ->
            t.format 'edit-power-up-settings'
      if hasPersonalSettings
        t.li onClick: removeData, ->
          t.a ->
            t.format 'remove-personal-settings'

module.exports = class extends React.Component
  displayName: "PluginSettings"

  render: ->
    template(@props)



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/plugin-settings-view.coffee